import { createSlice } from '@reduxjs/toolkit';

const supportReducer = createSlice({
  name: 'support',
  initialState: {
    activeSession: null,
    cursors: {},
    isConnected: false,
  },
  reducers: {
    setActiveSession: (state, action) => {
      state.activeSession = action.payload;
      state.isConnected = action.payload?.status === 'active';
    },
    setSupportCursor: (state, action) => {
      const { id, cursor } = action.payload;
      state.cursors[id] = cursor;
    },
    removeSupportCursor: (state, action) => {
      delete state.cursors[action.payload];
    },
    clearSupport: (state) => {
      state.activeSession = null;
      state.cursors = {};
      state.isConnected = false;
    },
  },
});

export const { setActiveSession, setSupportCursor, removeSupportCursor, clearSupport } = supportReducer.actions;
export default supportReducer.reducer;
